export default "__VITE_ASSET__3e37f43c__"